/* unplugin-vue-components disabled */import script from "./TimerRule.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimerRule.vue?vue&type=script&lang=ts&setup=true"

import "./TimerRule.vue?vue&type=style&index=0&id=481c847d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481c847d"]])

export default __exports__